// Fit against the actual announcement width, not a guessed device breakpoint.
if (!customElements.get('kiwibit-announcement-layout')) {
  customElements.define('kiwibit-announcement-layout', class extends HTMLElement {
    connectedCallback() {
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateLayout());
      };
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this);
      this.querySelectorAll('.announcement-bar__copy, .announcement-bar__actions > *').forEach(el => this.observer.observe(el));
      document.fonts?.addEventListener('loadingdone', this.schedule);
      window.addEventListener('resize', this.schedule, { passive: true });
      document.fonts?.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.fonts?.removeEventListener('loadingdone', this.schedule);
      window.removeEventListener('resize', this.schedule);
      cancelAnimationFrame(this.frame);
    }

    updateLayout() {
      if (!this.isConnected || !this.clientWidth) return;
      if (this.hasAttribute('data-inline-button')) {
        this.removeAttribute('data-stacked');
        this.dataset.layoutReady = 'true';
        return;
      }
      const copy = [...this.querySelectorAll('.announcement-bar__copy')].find(el => getComputedStyle(el).display !== 'none');
      const actions = this.querySelector('.announcement-bar__actions');
      if (!copy) return;
      // Synchronous intrinsic measurement; restore before the browser paints.
      // No cloned custom elements or extra countdown timers are created.
      const originalStyle = copy.getAttribute('style');
      Object.assign(copy.style, { width: 'max-content', maxWidth: 'none', whiteSpace: 'nowrap', flex: '0 0 auto' });
      const copyWidth = copy.getBoundingClientRect().width;
      if (originalStyle === null) copy.removeAttribute('style');
      else copy.setAttribute('style', originalStyle);
      const items = actions ? [...actions.children] : [];
      const actionWidth = items.reduce((sum, el) => sum + el.getBoundingClientRect().width, 0)
        + (actions ? Math.max(0, items.length - 1) * (parseFloat(getComputedStyle(actions).columnGap) || 0) : 0);
      const styles = getComputedStyle(this);
      const available = this.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
      const gap = actions ? (parseFloat(styles.columnGap) || 0) : 0;
      this.toggleAttribute('data-stacked', copyWidth + actionWidth + gap > available + 0.5);
      this.dataset.layoutReady = 'true';
    }
  });
}


// Keep each announcement instance bound to its own active block, including editor reloads.
if (!customElements.get('kiwibit-announcement-bar')) {
  customElements.define('kiwibit-announcement-bar', class extends HTMLElement {
    connectedCallback() {
      this.slideshow = this.querySelector('slideshow-component');
      this.onSlideChanged = event => this.applyColors(event.detail?.currentElement);
      this.onBlockSelect = event => {
        const slide = event.target.closest?.('[data-bar-background]');
        if (slide && this.contains(slide)) this.applyColors(slide);
      };
      this.slideshow?.addEventListener('slideChanged', this.onSlideChanged);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      const slides = this.querySelectorAll('[data-bar-background]');
      this.applyColors(slides[(this.slideshow?.currentPage || 1) - 1]);
    }

    disconnectedCallback() {
      this.slideshow?.removeEventListener('slideChanged', this.onSlideChanged);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    applyColors(slide) {
      if (!slide || !this.contains(slide)) return;
      this.style.setProperty('--announcement-bar-bg', slide.dataset.barBackground || '#003F22');
      this.style.setProperty('--announcement-bar-text', slide.dataset.barText || '#FFFFFF');
    }
  });
}
